import { styled } from '@mui/material';
import { Typography } from '@mui/material';

export const LimitControlsRoot = styled('div')({
  marginTop: '1rem',
  display: 'block',
  alignItems: 'center',
});

export const LimitControlsField = styled('div')({
  marginLeft: '1rem',
  display: 'flex',
  alignItems: 'center',
  flexGrow: 1,
  gap: '1rem',
});

export const LimitControlsTitle = styled(Typography)({
  display: 'flex',
  alignItems: 'center',
  textAlign: 'center',
  padding: 6,
  align: 'center',
});

export const PaddedTypography = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(1), // 24px (theme.spacing(3) = 3 * 8px)
  paddingLeft: '2px', // Custom pixel value
  align: 'center',
}));
